<template>
  <div class="btn-group">
    <button v-if="canAssignGroup" class="btn btn-secondary btn-sm" @click="assignGroups">
      <i class="fas fa-key"></i>
    </button>
    <button v-if="canView" class="btn btn-secondary btn-sm" @click="view">
      <i class="far fa-eye"></i>
    </button>
    <button v-if="canEdit" class="btn btn-secondary btn-sm" @click="edit">
      <i class="fas fa-edit"></i>
    </button>
    <button v-if="canDelete" class="btn btn-danger btn-sm" @click="confirmDeleting">
      <i class="fas fa-trash-alt"></i>
    </button>
    <button v-if="canRestore" class="btn btn-success btn-sm" @click="confirmRestore">
      <i class="fas fa-reply"></i>
    </button>
    <button v-if="canForceDelete" class="btn btn-danger btn-sm" @click="confirmForceDeleting">
      <i class="fas fa-trash-alt"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    row: Object,
  },

  computed: {
    /**
     * @return {string}
     */
    fullName() {
      return _.get(this.row, 'model.full_name');
    },

    /**
     * @return {boolean}
     */
    isTrashed() {
      return Boolean(_.get(this.row, 'model.is_trashed'));
    },

    /**
     * @return {boolean}
     */
    canView() {
      return this.row.canView && !this.isTrashed;
    },

    /**
     * @return {boolean}
     */
    canEdit() {
      return this.row.canEdit && !this.isTrashed;
    },

    /**
     * @return {boolean}
     */
    canAssignGroup() {
      return this.row.canAssignGroup && !this.isTrashed;
    },

    /**
     * @return {boolean}
     */
    canDelete() {
      return this.row.canDelete && !this.isTrashed;
    },

    /**
     * @return {boolean}
     */
    canRestore() {
      return this.row.canRestore && this.isTrashed;
    },

    /**
     * @return {boolean}
     */
    canForceDelete() {
      return this.row.canForceDelete && this.isTrashed;
    },

    /**
     * @return {string}
     */
    viewUrl() {
      return this.row.viewUrl;
    },

    /**
     * @return {string}
     */
    editUrl() {
      return this.row.editUrl;
    },

    /**
     * @return {string}
     */
    groupIndexUrl() {
      return this.row.groupIndexUrl;
    },

    /**
     * @return {string}
     */
    deleteUrl() {
      return this.row.deleteUrl;
    },

    /**
     * @return {string}
     */
    restoreUrl() {
      return this.row.restoreUrl;
    },

    /**
     * @return {string}
     */
    forceDeleteUrl() {
      return this.row.forceDeleteUrl;
    },
  },

  methods: {
    /**
     * @emits view
     */
    view() {
      this.$emit('view', {row: this.row, url: this.viewUrl});
    },

    /**
     * @emits edit
     */
    edit() {
      this.$emit('edit', {row: this.row, url: this.editUrl});
    },

    /**
     * @emits assign-groups
     */
    assignGroups() {
      this.$emit('assign-groups', {url: this.groupIndexUrl, name: this.fullName});
    },

    /**
     * @emits delete
     */
    confirmDeleting() {
      this.$confirm('Are you sure you want to delete this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => this.$emit('delete', {row: this.row, url: this.deleteUrl}))
          .catch(() => {
          });
    },

    /**
     * @emits restore
     */
    confirmRestore() {
      this.$confirm('Are you sure you want to restore this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => this.$emit('restore', {row: this.row, url: this.restoreUrl}))
          .catch(() => {
          });
    },

    /**
     * @emits forceDelete
     */
    confirmForceDeleting() {
      this.$confirm('Are you sure you want to permanently delete this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => this.$emit('force-delete', {row: this.row, url: this.forceDeleteUrl}))
          .catch(() => {
          });
    },
  },
}
</script>
